<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="500" @keydown.esc="vratiRezultat(false)">
      <template v-slot:activator="{ on }">
      </template>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title> {{$t('common.dialog_title')}} </v-card-title>
        <v-card-text v-html="text"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="default" round flat @click="vratiRezultat(false)"><span class="white--text"> {{ $t('common.dialog_cancel_btn') }} </span></v-btn>
          <v-btn class="primary " round flat @click="vratiRezultat(true)"><span class="white--text"> {{ getconfirmationButtonText() }}</span></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>


<script>
  export default {
    props: {
      confirmationButtonText: null
    },
    data () {
      return {
        dialog: false,
        callbackFunction: () => { },
        text: ''
      }
    },
    methods: {
      getconfirmationButtonText() {
        if (this.confirmationButtonText == null) {
          return this.$t('common.dialog_ok_btn');
        } else {
          return this.confirmationButtonText;
        }
      },

      showDialog(callback, text) {
        this.text = text;
        this.callbackFunction = callback;
        this.dialog = true;
      },

      vratiRezultat(isOk) {
        this.dialog = false;
        this.callbackFunction(isOk);
      },

      
    }
  }
</script>



// WEBPACK FOOTER //
// VueSrc/Common/Components/ConfirmationDialog.vue